<div>
    <div class="grid-container grid-5">
        @if (classifications.value().length > 0) {
            <div
                class="radio-buttons grid-span-5 m-2 grid-container grid-10"
                advizeoBooleanControlGroup
                [ngModel]="selectedFavoriteClassification"
                (ngModelChange)="selectedFavoriteClassification = $event"
            >
                @for (classification of classifications.value(); track classification) {
                    <ui-radio-button
                        class="radio-button grid-span-9"
                        controlValueAccessorInterop
                        [label]="classification.breadcrumb"
                        [advizeoBooleanControlValue]="classification"
                    />
                    <ui-icon-button class="grid-span-1" iconName="delete" (click)="deleteFavoritePerimeter(classification)" />
                }
            </div>
        }
        <div class="p-4 grid-span-5">
            <loading-and-error [resource]="classifications" />
        </div>
    </div>
    <div class="advizeo-toolbar toolbar-right large-padding-top">
        <button ui-button color="default" (click)="cancel()">
            {{ 'BUTTONS.CANCEL' | translate }}
        </button>
        <button ui-button color="primary" [disabled]="selectedFavoriteClassification === null" (click)="validate()">
            {{ 'COMPONENTS.MAIN_CLASSIFICATION_NODE_SELECTOR.APPLY_SAVED_FAVORITES_PERIMETER' | translate }}
        </button>
    </div>
</div>
